import { takeLatest, select, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { signUp, signUpCode, setToken } from 'api';
import { TELEPHONE_CODE, URLS } from 'config';
// import { generateNextRoute } from 'utilz';

import { showLoadScreen, hideLoadScreen } from 'components/LoadScreen/actions';
import { showNotification } from 'components/Notification/actions';
import { saveUser } from 'pages/Login/actions';
import * as actions from './actions';

function* sendPhoneNumber(action) {
  const state = yield select();
  const { payload: { callback, isSignIn } } = action;
  const { phone: { phone } } = state;

  try {
    const result = yield call(signUp, phone, isSignIn);
    yield put(showNotification({
      title: 'SMS Successfully sent',
      callback
    }));
    // yield put(actions.setExpectedCode(result.data.textSMS.body.match(/\d/g).join('')));
    yield put(actions.setExpectedCode(`${result.data.message.activationCode}`));
  } catch (err) {
    console.log(err);
  }
}

function* sendCodeActivation(action) {
  const state = yield select();
  const { payload: { callback, isSignIn } } = action;
  const {
    phone: { phone, expectedCode },
    carType: { carType },
    budget: { budget },
    needs: { needs }
  } = state;
  const body = {
    telephoneNumber: `${TELEPHONE_CODE}${phone}`,
    activationCode: Number(expectedCode)
  };

  if (!isSignIn) {
    body.typeOfCar = carType;
    body.userMonthlyBudget = budget;
    body.whyUserNeedCar = needs.filter(el => el !== '');
  }

  try {
    yield put(showLoadScreen());
    const result = yield call(signUpCode, body, isSignIn);
    yield put(hideLoadScreen());
    yield put(showNotification({
      title: 'Code accepted',
      callback
    }));

    if (!isSignIn) {
      if (result.data.user.lastRoute !== URLS.BASE) {
        yield put(push(URLS.RETURNED));
        // yield put(push(result.data.user.lastRoute));
      } else {
        yield put(push(URLS.NAME));
      }
      // yield put(push(generateNextRoute(result.data.user)));
    }
    if (isSignIn) {
      yield put(saveUser(result.data.user));
    }
    setToken(result.data.jwt);
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}


export default function* () {
  yield takeLatest(
    actions.PHONE_SEND,
    sendPhoneNumber
  );
  yield takeLatest(
    actions.CODE_SEND,
    sendCodeActivation
  );
}



// WEBPACK FOOTER //
// ./src/pages/Phone/saga.js